import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { EventDetailsModel, EventProvider } from '../../../../providers/event/event';
import { LoaderProvider } from '../../../../providers/loader/loader';

/**
 * Generated class for the MyTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'event-create-tabs',
  templateUrl: 'event-create-tabs.html',
})
export class EventCreateTabsPage {
  createPage: string = 'event';
  eventModel: EventDetailsModel = {
    contentsInfos: "",
    booleanData: "",
    contentsKontakt: "",
    country: "",
    cid: 0,
    date: 0,
    images: [],
    kontaktCity: "",
    id: -1,
    eventStatus: "",
    evtStat: "",
    kontaktCountry: "",
    kontaktLink: "",
    kontaktMail: "",
    kontaktName: "",
    price: 0,
    kontaktPlz: "",
    kontaktStreet: "",
    kontaktStreetN: "",
    kontaktTel: "",
    lateRegistration: 0,
    name: "",
    place: "",
    plz: "",
    presentCeremony: 0,
    routeData1: "",
    routeData2: "",
    routeData3: "",
    state: "",
    streckeconv: "",
    webPage: "",
    wertung: "",
    wertungList: [],
    lat: 0,
    lng: 0,
    isOwner: true,
    eventType: ""
  };
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    private eventService: EventProvider,
    private loadingCtrl: LoaderProvider,
    private translate: TranslateService,
    public detector: AppDetectorProvider
    ) { }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MyTabsPage');
  }

  save() {
    let hasError = false;
    let errorTexts = "";
    if (this.eventModel.name.length === 0) {
      // error name
      hasError = true;

      errorTexts += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("EVENT_EVENTNAME") }) + "\n";
    }
    if (!this.eventModel.webPage.startsWith('http://') && this.eventModel.webPage.length < 11) {
      // webpage error
      hasError = true;
      errorTexts += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("EVENT_WEBPAGE") }) + "\n";
    }
    if (!this.eventModel.state) {
      // stete error
      hasError = true;
      errorTexts += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("EVENT_STATE") }) + "\n";
    }
    if (this.eventModel.wertungList.length < 1) {
      hasError = true;
      errorTexts += this.translate.instant("GLOBAL_ERROR_AT_LEAST_X_Y_IS_REQUIRED", { count: 1, name: this.translate.instant("EVENT_ROUND") }) + "\n";

    }

    if (hasError) {
      this.toastCtrl.create({ message: errorTexts, duration: 6000, showCloseButton: true }).present();
    } else {
      let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
      loader.present();
      this.eventService.createEvent(this.eventModel).then(() => {
        loader.dismiss();
        this.toastCtrl.create({ message: this.translate.instant("EVENT_CREATE_SAVE_SUCCESS"), duration: 6000, showCloseButton: true }).present();
      }, err => { console.log("reject", err); loader.dismiss(); }).catch(err => {
        console.log("catch", err);
        loader.dismiss();
      });

    }

    console.log(this.eventModel, "TODO save");
  }


}



// WEBPACK FOOTER //
// /src/pages/event/create/event-create-tabs/event-create-tabs.ts